import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/de/disclaimer")({
  head: () => ({
    meta: [
      { title: "Haftungsausschluss — Picamini.online" },
      {
        name: "description",
        content: "Haftungsausschluss und rechtliche Hinweise zur Nutzung der Dienste auf Picamini.online.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/de/haftungsausschluss" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/disclaimer" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/aviso-legal" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/haftungsausschluss" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/disclaimer" },
    ],
  }),
  component: DeDisclaimerPage,
});

function DeDisclaimerPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="de" />

      <main className="flex-1 py-12 mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="space-y-3">
          <h1 className="text-3xl font-extrabold sm:text-4xl text-foreground">Haftungsausschluss (Disclaimer)</h1>
          <p className="text-sm text-muted-foreground">Stand: September 2026</p>
        </div>

        <div className="surface-card p-6 sm:p-8 rounded-2xl bg-card border space-y-6 text-sm text-muted-foreground leading-relaxed">
          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">1. Haftung für Inhalte</h2>
            <p>
              Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">2. Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-bold text-foreground">3. Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht.
            </p>
          </section>
        </div>
      </main>

      <SiteFooter lang="de" />
    </div>
  );
}
